import axios from '@axios'

export default {
  insertTransferencia(data) {
    return axios.post('/financeiro/transferencias', data)
  },
  updateTransferencia(id, data) {
    return axios.put(`/financeiro/transferencias/${id}`, data)
  },

  deleteTransferencia(id) {
    return axios.delete(`/financeiro/transferencias/${id}`)
  },
  filtroTransferencias(pageConfig, filter) {
    const page = pageConfig.page - 1
    const { size, sort, order } = pageConfig
    const queryUrl = `?page=${page}&size=${size}&sort=${sort},${order}`
    return axios.post(`/financeiro/transferencias/filtro${queryUrl}`, filter)
  },
}
